<!-- Start Footer Area -->
<section class="footer-area">
    <div class="container">
        <div class="row">

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-footer-widget pl-5">
                    <h3>About</h3>

                    <p style="color: #fff;">Give your business online presence and boost your business with EWNS powered digital solutions like website which is optimized for hyper local search on popular search engines and unique digital marketing strategies which help you acheive desired ROI</p>
                </div>
            </div>
           

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Quick Links</h3>

                    <ul class="footer-quick-links">
                        <li><a href="https://ewns.in" title="Home" itemprop="url">Home</a></li>

                        <li><a href="https://portal.ewns.in/signup" title="Register as Merchant" itemprop="url">Register</a></li>

                        <li><a href="https://ewns.in/about" title="About" itemprop="url">About</a></li>

                        <li><a href="https://portal.ewns.in" title="Login as Merchant" itemprop="url">Login</a></li>

                        <li><a href="https://ewns.in/blog/1" title="Blog" itemprop="url">Blog</a></li>

                        <li><a href="https://ewns.in/testimonials" title="Testimonials" itemprop="url">Testimonials</a></li>

                        <li><a href="https://ewns.in/services" title="Services" itemprop="url">Services</a></li>

                        <li><a href="https://ewns.in/faq" title="FAQ" itemprop="url">FAQ</a></li>

                        <li><a href="https://ewns.in/pricing" title="Pricing" itemprop="url">Pricing</a></li>

                        

                        <li><a href="https://ewns.in/refund" title="Refund Policy" itemprop="url">Refund Policy</a></li>

                        

                        <li><a href="https://ewns.in/contact" title="Contact" itemprop="url">Contact</a></li>

                        <li><a href="https://ewns.in/sitemap.xml" title="Sitemap" itemprop="url">Sitemap</a></li>

                        
  
                    </ul>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Contact Info</h3>

                    <ul class="footer-contact-info">
                        <li>
                            <i class="flaticon-phone-call"></i>
                            <span>Mon to Sat : 10:00AM - 06:00PM</span>
                            <a href="tel:+919032526393">+91 9032526393</a>
                        </li>
                        <li>
                            <i class="flaticon-email"></i>
                            <span>Do You Have a Question?</span>
                            <a href="mailto:sales@ewns.in">sales@ewns.in</a>
                        </li>
                        <li>
                            <i class="flaticon-social-media"></i>
                            <span>Socials Network</span>
                            <ul class="social">
                                <li><a href="https://twitter.com/ewnsdotin" target="_blank"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="https://www.facebook.com/ewns.in" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="https://www.instagram.com/ewns.in/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                                <li><a href="https://www.linkedin.com/company/ewnsdotin/" target="_blank"><i class="fab fa-linkedin"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-youtube"></i></a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>

            
        </div>

        <div class="copyright-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <p>All rights reserved</p>
                </div>

                <div class="col-lg-6 col-sm-6 col-md-6">
                    <ul>
                        <li><a href="https://ewns.in/terms" itemprop="url" title="Terms & Conditions">Terms & Conditions</a></li>
                        <li><a href="https://ewns.in/privacy" itemprop="url" title="Privacy Policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Footer Area -->

<div class="go-top"><i class="fas fa-chevron-up"></i></div>